import script from "./PasswordForget.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordForget.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordForget.vue?vue&type=style&index=0&id=ab2eab34&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab2eab34"]])

export default __exports__